<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { get } from "lodash";

export default {
  mixins: [fandomBasicMixin],
  methods: {
    redirectToUserTarget() {
      Fandom.setCookie('signup-thankyou-modal', true);
      const redirectCookie = Fandom.readCookie('redirect_after_profile_form')
      if (!!redirectCookie) {
        window.location.href = Fandom.applyContextToUrl(decodeURIComponent(redirectCookie.split("=")[1]));
      } else {
        window.location.href = "/";
      }
    },
    afterSubmitCallback() {
      Fandom.ajax({
        url: '/api/v5/set_user_string_efs',
        method: 'POST',
        data: {
          additional_extra_fields: {
            "newsletter": true
          }
        },
        success: (data) => {
          this.redirectToUserTarget();
        }
      });
    }
  },
  computed: { },
};

</script>

<template>
  <div 
    v-easyadmin="easyadminId" 
    v-if="isContentVisibleToUser()" 
    :class="[contentType]" 
    class="bg-gray-200"
    page-after-signup-component
  >
    <div class="container text-center py-5">
      <h3 v-if="content.title">{{content.title}}</h3>
      <div class="row justify-content-center">
        <div class="col-12 col-lg-6 py-5">
          <div v-for="(keypoint, index) in content.keypoints" :key="`keypoint-${index}`" class="py-2">
            <div class="d-flex align-items-start align-items-md-center justify-content-center">
              <div class="icon-container">
                <img :src="keypoint.icon.url" v-if="keypoint.icon" class="keypoint-icon"/>
              </div>
              <div class="keypoint-text text-left ml-3">
                <div class="font-weight-bold" v-if="keypoint.title">{{keypoint.title}}</div>
                <div class="small mb-0" v-if="keypoint.description" v-html="keypoint.description"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12 col-lg-6" v-if="content.form_content">
          <generic-form @done="afterSubmitCallback()" :content="getContent(content.form_content)"></generic-form>
        </div>
        <div class="col-12 d-flex justify-content-center">
          <button class="btn btn-primary mt-3 flex-grow-1 flex-sm-grow-0" @click="redirectToUserTarget()">
            {{ft('globals.skip')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[page-after-signup-component] {
  .icon-container, .keypoint-icon {
    width: 100px;
    height: 100px;

    @include media-breakpoint-down(sm) {
      width: 50px;
      height: 50px;
    }
  }

  [generic-form-component]::v-deep {
    color: $dark;

    .form-control {
      border: 1px solid $black;
      background-color: $white;
    }

    .form-group {
      text-align: left;
    }

    button[type="submit"] {
      margin-top: 1.5rem;
    }
  }
}
</style>